// const base_url = "https://ukvisa.herosolutions.com.pk/api/";
// const base_url = "http://localhost/work/ukvisa/";
// const base_url = "http://localhost/work/ukvisa-new/api/";
// const base_url = "http://localhost/herosols/ukvisa/ukvisa-server/";
// const base_url = "https://my.ukvisajobs.com-api/";
// const base_url = "https://herosolutions.com.pk/abida/ukvisajobs/";
const base_url = "https://my.ukvisajobs.com/ukvisa-api/";
const live_base_url =
  process.env.REACT_APP_ENV_MODE === "development" ? "" : "";
const public_site_link = "https://ukvisajobs.com/";
const resources_link = "https://ukvisajobs.com/resources";
const community_link = "https://ukvisajobs.com/community";
const events_link = "https://ukvisajobs.com/events";
const faqs_link = "https://ukvisajobs.com/faq";
const help_and_support_link = "https://ukvisajobs.com/help-support";

// Cookie Config
const cookieDomain =
  process.env.REACT_APP_ENV_MODE === "development"
    ? "localhost"
    : process.env.REACT_APP_DOMAIN;
const cookiePath = "/";
const CHK_EXPLORE_PLAN_DATE = "2026-02-17";
// const live_base_url = "";
// const public_site_link = "http://localhost:3000/";
// const resources_link = "http://localhost:3000/resources";
// const community_link = "http://localhost:3000/community";
// const events_link = "http://localhost:3000/events";
// const faqs_link = "http://localhost:3000/faq";
// const help_and_support_link = "http://localhost:3000/help-support";

module.exports = {
  API_BASE_URL: `${base_url}api/`,
  SITE_BASE_URL: `${live_base_url}`,
  PUBLIC_SITE_URL: `${public_site_link}`,
  API_UPLOADS_URL: `${base_url}uploads/`,
  API_ASSETS_IMAGES_URL: `${base_url}assets/images/`,
  API_CMS_BG_IMAGES_URL: `${base_url}uploads/images/`,
  resources_link: resources_link,
  community_link: community_link,
  events_link: events_link,
  faqs_link: faqs_link,
  help_and_support_link: help_and_support_link,
  CHK_EXPLORE_PLAN_DATE: CHK_EXPLORE_PLAN_DATE,

  COOKIE_CONFIG: {
    domain: cookieDomain,
    path: cookiePath,
  },
};
